import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";
import { Config } from "@/utils/config.utils";
import { sortBy } from "@/utils/general";

import { DISCRIMINATORS } from "./wishlist.discriminators";
import { $WishlistModuleName, TWishlistState } from "./wishlist.types";

const { isLoading } = generateDefaultSelectors($WishlistModuleName);

const emptyWishlist: TWishlistState = [];

const getWishlists = (state: IState) =>
    getApiDataState(state, $WishlistModuleName)?.data || emptyWishlist;

const getListWithId = (id?: string) => (state: IState) =>
    getWishlists(state).find((l) => l.id === id);

const getLastUsedWishlist = (state: IState) => {
    return getWishlists(state)
        .sort(sortBy("lastUpdated", Config.getLocale(), false))
        .reverse()
        .at(0);
};

const getFirstWishList = (state: IState) => {
    const wishlists = getWishlists(state);
    const wishlistsWithProducts = wishlists.filter(
        (l) => l.products.length > 0
    );

    if (wishlistsWithProducts.length === 1) {
        return wishlistsWithProducts.at(0);
    }

    if (wishlistsWithProducts.length > 1) {
        const sortedByProductsLength = wishlists.sort(
            (a, b) => b.products.length - a.products.length
        );

        const firstProduct = sortedByProductsLength.at(0);
        const equalToFirstProductLength = sortedByProductsLength.filter(
            (l) => l.products.length === firstProduct?.products.length
        );

        return equalToFirstProductLength
            .sort(sortBy("name", Config.getLocale(), false))
            .at(0);
    }

    return wishlists.at(0);
};

const canRemoveList = (state: IState) => getWishlists(state).length > 1;

const isLoadingOne = (state: IState): boolean => {
    return !!getApiDataState(state, $WishlistModuleName)?.[
        DISCRIMINATORS.LoadOne
    ]?.loading;
};

export {
    canRemoveList,
    getFirstWishList,
    getLastUsedWishlist,
    getListWithId,
    getWishlists,
    isLoading,
    isLoadingOne
};
